// removed by extract-text-webpack-plugin
module.exports = {"card-wrapper":"AppCard__card-wrapper___39yKP","card":"AppCard__card___ZrzoF","single":"AppCard__single___2VIvH","dark":"AppCard__dark___3bFMv","details":"AppCard__details___18btH","category":"AppCard__category___1cTLk _typography__text-ellipsis___tUHkx","title":"AppCard__title___cR4ci _typography__h6___1u75q _typography__headers___eO5yD _typography__text-ellipsis___tUHkx","meta-info":"AppCard__meta-info___ny40O","desc":"AppCard__desc___2JENW"};


//////////////////
// WEBPACK FOOTER
// /opt/build/repo/packages/components/AppCard/AppCard.scss
// module id = 524
// module chunks = 0